import { ecsApi } from '@services';
import {
    Constructor,
    Feedback,
    Problem,
    Level,
    PremadePayload,
    ProductFeedbackPayload,
    ProductIdentification,
    GetAllEventsFeedbacksResponse
} from './feedback.types';
import { GetUsersResponse } from '@services';

export const feedbackApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getFeedbacks: builder.mutation<Feedback[], void>({
            query: () => ({
                url: '/products/premade',
                method: 'GET'
            })
        }),
        getConstructors: builder.mutation<Constructor[], void>({
            query: () => ({
                url: '/constructors',
                method: 'GET'
            })
        }),
        getProblems: builder.mutation<Problem[], void>({
            query: () => ({
                url: '/products/problems',
                method: 'GET'
            })
        }),
        createFeedback: builder.mutation<void, PremadePayload>({
            query: (payload) => ({
                url: '/products/premade',
                method: 'POST',
                body: payload
            })
        }),
        getLevels: builder.mutation<Level[], void>({
            query: () => ({
                url: '/products/levels',
                method: 'GET'
            })
        }),
        getUsers: builder.mutation<GetUsersResponse, void>({
            query: () => ({
                url: '/users',
                method: 'GET'
            })
        }),
        getProductIdentifications: builder.mutation<ProductIdentification[], void>({
            query: () => ({
                url: '/products/identification',
                method: 'GET'
            })
        }),
        createProductFeedback: builder.mutation<void, ProductFeedbackPayload>({
            query: (payload) => ({
                url: '/products/feedback',
                method: 'POST',
                body: payload
            })
        }),
        getEventsFeedbacks: builder.mutation<GetAllEventsFeedbacksResponse, void>({
            query: () => ({
                url: '/lifts',
                method: 'GET'
            })
        })
    })
});

export const {
    useGetFeedbacksMutation,
    useGetConstructorsMutation,
    useGetProblemsMutation,
    useCreateFeedbackMutation,
    useGetLevelsMutation,
    useGetUsersMutation,
    useGetProductIdentificationsMutation,
    useCreateProductFeedbackMutation,
    useGetEventsFeedbacksMutation
} = feedbackApi;
